module.exports = __webpack_public_path__ + "img/202306_03.c1634346.jpg";